import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { VideoComponent } from './video.component';


@Component({
    imports:[VideoComponent],
    selector: 'app-tutorial-dialog',
    templateUrl: './tutorial.component.html',
    styleUrls: ['./tutorial.component.scss'],
    standalone: true
})
/** InformationDialog component*/
export class TutorialDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<TutorialDialogComponent>,
        protected router: Router) { }


    onNoClick(): void {
        this.dialogRef.close();
        
    }
    closeClick() {
        this.dialogRef.close();
    }
}
